<template>
    <div class="editable-form">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "EditableTable",
        props: {
            actionUrl: String,
            responseHandler: Function,
            formId: String
        },
        data() {
            return {
                axios: window.axios,
            }
        },
        mounted() {
            this.$on('inputSubmit', this.submitIndividualInput);
            this.$on('editAll', this.editAllFields);
        },
        computed: {
            callback() {
                return this.responseHandler ?? window.handleResponse ?? (() => {});
            }
        },
        methods: {
            submitIndividualInput(editableInput) {
                this.axios.post(this.actionUrl, {
                    ...editableInput.extra,
                    field: editableInput.fieldType,
                    originalValue: editableInput.original,
                    value: editableInput.newValue
                }).then(response => {
                    this.callback.call(this, response);
                    editableInput.original = editableInput.newValue;
                    editableInput.value = editableInput.newValue;
                }).catch(error => {
                    editableInput.value = editableInput.original;
                    let announcementMessage = "Something went wrong, please try again later or check what you entered";
                    if (error.response.data) {
                        announcementMessage = error.response.data.error;
                    }
                    window.store.setAnnouncementMessageAction(announcementMessage);
                }).finally(() => {
                    editableInput.editing = false;
                })
            },
            editAllFields({ editing, cancel }) {
                if (editing && !cancel) {
                    $(this.formId).submit();
                }
                this.$children.forEach(child => {
                    child.editing = !editing;
                });
            }
        },
    }
</script>

<style scoped>

</style>
